import { EmployeeInput } from 'domain/shared/employee';
import { Checkbox } from 'framework/form';
import type { CreateEditFormSection } from 'framework/ViewTypes/contentLayout';

export const getPositionSlotAssignmentFormSections = (
  hasWorker: boolean,
  hasPositionFulfillmentRequest: boolean,
): CreateEditFormSection[] => [
  {
    id: 'position-assignment',
    fields: [
      {
        id: 'worker',
        size: { xs: 12, md: 6, xl: 6 },
        content: <EmployeeInput source="employeeAlias" label="Worker" isInitialNameLoad />,
      },
      {
        id: 'requiredReplacement',
        size: { xs: 12, md: 6, xl: 6 },
        content: (
          <Checkbox
            source="requiredReplacement"
            tooltip="Allows a position fill request to be created while the position is occupied."
            label="Required replacement"
            isVisible={hasWorker}
            disabled={hasPositionFulfillmentRequest}
          />
        ),
      },
    ],
  },
];
